import { FC } from 'react';
import type { NotificationResponse } from '@monorepo/notification-common';
import { List, ListItem } from '@monorepo/nova-ui';
import { NotificationItem } from './notification-item';

type Props = {
  displayedNotifications: NotificationResponse[];
};

export const NotificationsContent: FC<Props> = ({ displayedNotifications }) => {
  return (
    <List
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        padding: 0,
      }}
    >
      {displayedNotifications.map((item) => (
        <ListItem key={item.id} sx={{ padding: 0 }}>
          <NotificationItem
            id={item.id}
            type={item.type}
            values={item.values}
            createdAt={item.createdAt}
            seen={item.seen}
          />
        </ListItem>
      ))}
    </List>
  );
};
